<template>
<div class="container">
    <div class="list">
        <div class="item">
            <div class="title">
                <span class="seckill">秒杀折扣</span>
                <img width="15px" height="15px" style="padding-left: 0.13333rem;" src="../../../../assets/icon/icon-seckill.png" alt="" />
                <span class="time">限时抢购</span>
            </div>
            <div class="seckillimg" @click="detail(productList[0].id)">
                <img :src="productList[0].pictureUrl" alt="" width="100%;" />
                <div class="ms">
                    <img width="100%" src="../../../../assets/icon/icon_miaosha.png" alt="" />
                </div>
            </div>
            <div>
                <div class="cationtitle">{{ productList[0].chineseName }}</div>
                <div class="cationintegral">
                    <span class="cationspan">{{ productList[0].integralNum }}积分</span>
                </div>
            </div>
        </div>
        <div class="item">
            <div class="title">
                <span class="seckill">兑换赠礼</span>
                <img width="15px" height="15px" style="padding-left: 0.13333rem;" src="../../../../assets/icon/icon-exchange.png" alt="" />
                <span class="time">多兑多得</span>
            </div>
            <div class="seckillimg" @click="detail(productList[1].id)">
                <img :src="productList[1].pictureUrl" alt="" width="100%;" />
                <div class="ms">
                    <img width="100%" src="../../../../assets/icon/icon_miaosha.png" alt="" />
                </div>
            </div>
            <div>
                <div class="cationtitle">{{ productList[1].chineseName }}</div>
                <div class="cationintegral">
                    <span class="cationspan">{{ productList[1].integralNum }}积分</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    queryByProductId
} from "@/api/api";
export default {
    components: {},
    props: ["cmsData"],
    data() {
        return {
            productList: [{
                    productUrl: "",
                },
                {
                    productUrl: "",
                },
            ],
        };
    },
    watch: {},
    computed: {},
    methods: {
        async queryProduct() {
            let tempList = [];
            this.cmsData.seckilList.map((value) => {
                tempList.push({
                    id: value.id,
                });
            });
            let params = {
                list: tempList,
                showTerminal: 1,
                showDesk: 2,
            };

            const res = await queryByProductId(params);
            this.productList = res.data;
        },
        detail(id) {
            this.$router.push({
                path: "/productDetails?id=" + id,
            });
        },
    },
    created() {},
    mounted() {
        this.queryProduct();
    },
};
</script>

<style lang="scss" scoped>
.cationtitle {
    padding-top: 10px;
    font-size: 28px;
    color: #111;
}

.cationtext {
    font-size: 26px;
    color: #999;
    padding-top: 10px;
}

.cationtitle,
.cationtext {
    width: 250px;
    margin: 0 auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.cationintegral {
    padding-top: 20px;
    text-align: center;
    // font-size: 25px;
}

.exchange {
    padding-top: 20px;
    font-size: 25px;
}

.cationspan {
    color: rgb(209, 80, 79);
    font-size: 25px;
    padding-right: 6px;
}

.container {
    width: 100%;
    // background: #f7f7f7;
    padding: 20px 0;

    .list {
        margin: 0 10px;
        display: flex;
    }
}

.item {
    flex: 1;
    background: #fff;
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    padding: 10px 0;

    .ms {
        width: 120px;
        // height: 80px;
        position: absolute;
        top: 0;
        left: 0;
    }
}

.seckillimg {
    position: relative;
    width: 300px;
    height: 300px;
    margin: 0 auto;
    padding-top: 10px;
}

.title {
    padding-left: 20px;
    padding-bottom: 20px;
}

.seckill {
    font-size: 33px;
    font-weight: bold;
}

.time {
    color: red;
    padding-left: 10px;
}
</style>
